import { Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { trigger, transition, style, animate, keyframes, query, stagger} from '@angular/animations';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';

import { EditExpenseComponent } from '../edit-expense/edit-expense.component';

import { MatDialog } from '@angular/material/dialog';
// import {MatTableDataSource} from '@angular/material/table';
// import {SelectionModel} from '@angular/cdk/collections';
// import { Utils } from '../../../utils/utils';
import { RefDataService } from '../../services/context/ref-data.service';
import { FormControl, Validators } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'gp-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.scss'],
  animations: [
    trigger(
      'modalFadeZoom',
      [
        transition(
          ':enter', [
            style({ transform: 'translateX(-50%) translateY(-50%) scale(.7)', opacity: 0 }),
            animate('0.3s', style({ opacity: 1, transform: 'translateX(-50%) translateY(-50%) scale(1)' })),
          ]
        ),
        transition(
          ':leave', [
            style({ opacity: 1, transform: 'translateX(-50%) translateY(-50%) scale(1)' }),
            animate('5.3s', style({ opacity: 0, transform: 'translateX(-50%) translateY(-50%) scale(.7)' })),
          ]
        ),
      ]),

      trigger('fadeSlideGrowKeyframe', [
        transition(':enter', [
          style({ opacity: 0, transform: 'scale(0.5) translateY(50px)' }),
          animate(
            '400ms',
            keyframes([
              style({ opacity: 1, offset: 0.3 }),
              style({ transform: 'translateY(0)', offset: 0.6 }),
              style({ transform: 'scale(1)', offset: 1 }),
            ])
          ),
        ]),
        transition(':leave', [
          style({ opacity: 1, transform: 'scale(-0.5) translateY(50px)' }),
          animate(
            '400ms',
            keyframes([
              style({ opacity: 0, offset: 0.3 }),
              style({ transform: 'translateY(0)', offset: 0.6 }),
              style({ transform: 'scale(1)', offset: 1 }),              
            ])
          ),
        ]),
      ]),

      trigger('fadeInGrow1', [
        transition(':enter', [
          style({ opacity: 0}),
          animate(
            '400ms',
            keyframes([
              style({ opacity: 1, offset: 0.3 }),
              style({ transform: 'translateY(0)', offset: 0.6 }),
              style({ transform: 'scale(1)', offset: 1 }),
            ])
          ),
        ]),
        transition(':leave', [
          style({ opacity: 1}),
          animate(
            '400ms',
            keyframes([
              style({ opacity: 0, offset: 0.3 }),
              style({ transform: 'translateY(0)', offset: 0.6 }),
              style({ transform: 'scale(1)', offset: 1 }),              
            ])
          ),
        ]),
      ]),



      trigger('fadeInGrow', [
        transition(':enter', [
          query(':enter', [
            style({ opacity: 0 }),
            stagger('50ms', [
              animate('500ms', style({ opacity: 1 }))])
          ])
        ]),
        // transition(':leave', [
        //   query(':leave', [
        //     style({ opacity: 1 }),
        //     stagger('50ms', [
        //       animate('500ms', style({ opacity: 0 }))])
        //   ])
        // ])
      ])

     
  ]
})
export class GoalsComponent implements OnInit, OnDestroy {

  // displayedColumns: string[] = ['select', 'expDesc', 'owner', 'amount', 'growthType', 'startYr', 'endYr', 'actions'];
  // Expenses: any = [];
  // SelectedExpenses: any = [];
  // dataSource;
  // dataSource = new MatTableDataSource<any>(this.Expenses);
  // goalDataSource: fromModel.Goal[];
  // selection = new SelectionModel<any>(true, []);
  // showCreateExpense = false;
  // planExpenses: fromModel.Expense[];
  // editLeft;
  // editTop;


  protected _storeDataSubscription: Subscription;

  //amount = new FormControl('', [Validators.required,  Validators.min(1) ]);
  //@ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;


  

  showDetails = false;
  showEdit = false; 

  selectedGoalId;
  selectedGoalSummary;
  
  goalExpNotIncludedMsg = "Goal expenses are not included";
  
  goals = [];
  goalsRef: fromModel.CodeValue[] = [];

  refreshGoalExpense = false;

  showLevel2Progress = true;
  
  constructor(private contextService:ContextService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private refDataService: RefDataService,
    private dialog: MatDialog, 
    private appMonitoringService: AppMonitoringService) {      
  }

  ngOnInit(): void {
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));      
    this.dataService.getGoalSummary();
    //this.populatePlanGoalsFromRefData();
    this.goalsRef  = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals);
    this.populatePlanGoals();
    //this.goals = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals);
    
  }

 
  private populateAppData(appData: fromModel.IAppData){
    if(appData && (appData.action===fromModel.DATA_ACTION.UPDATESETTINGS)){        
      //this.dataService.getGoalSummary();
      this.dataService.getPlanAnalysis(); 
      this.refreshMe();
    }

    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){
      this.populatePlanGoals();      
    }
  }

  private populatePlanGoals(){
    this.goals = [];
    let goalId='';
    let priority=0;
    let color='';
    let planGoals  = this.dataService.getAllGoals();

    if(this.goalsRef && planGoals){
      this.goalsRef.forEach(goalRef => {
        let _goal = planGoals.find(goal=>goal.goalType === goalRef.code);
        goalId = '';
        if(_goal){
          goalId = _goal.goalId;
          priority = _goal.priority;
        }
        color = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.GoalsColor, goalRef.code).value;
        this.goals.push({goalId: goalId, goalType: goalRef.code, goalDesc: goalRef.value, priority: priority, color: color});      
      });
  
      let goalsSummary = this.dataService.getGoalSummaryArray();    
      this.showLevel2Progress  = true;
      if(goalsSummary && goalsSummary.Error){  
        //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "GoalsComponent-populatePlanGoals", false);
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "GoalsComponent-populatePlanGoals", {ShowMsg: true,  MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.systemErrorMsg});
        this.showLevel2Progress = false;
      } else {
        if(this.goals && this.goals.length>0 && goalsSummary && goalsSummary.length>0){
          this.goals.forEach((goal, index) => {
            let _g = goalsSummary.find(_goal=>_goal.goalId === goal.goalId);
            if(_g){
              _g.goalType = goal.goalType;
              _g.goalDesc = goal.goalDesc;
              _g.priority = goal.priority;            
              _g.color = goal.color;
              this.goals[index] = _g;
            }
          });
          this.showLevel2Progress = false;
        }
        
        if(this.selectedGoalId && !this.selectedGoalSummary){
          this.selectedGoalSummary = goalsSummary.find(_goal=>_goal.goalId === this.selectedGoalId);
        }
      }

      // if(goalsSummary){  
      //   // this.goals.forEach((goal, index) => {
      //   //   let _g = goalsSummary.find(_goal=>_goal.goalId === goal.goalId);
      //   //   if(_g){
      //   //     _g.goalType = goal.goalType;
      //   //     _g.goalDesc = goal.goalDesc;
      //   //     _g.priority = goal.priority;            
      //   //     _g.color = goal.color;
      //   //     this.goals[index] = _g;
      //   //   }
      //   // });

      //   if(this.selectedGoalId && !this.selectedGoalSummary){
      //     this.selectedGoalSummary = goalsSummary.find(_goal=>_goal.goalId === this.selectedGoalId);
      //   }
      // }


      // console.log("this.goals: " + JSON.stringify(this.goals));
      // if(this.selectedGoalId && !this.selectedGoalSummary){
      //   this.selectedGoalSummary = goalsSummary.find(_goal=>_goal.goalId === this.selectedGoalId);
      // }

      
    }
    
    
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, expenseId: string, goalType: fromModel.GOALTYPE){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.EDITEXPENSE: {
        const dialogRef = this.dialog.open(EditExpenseComponent, {
          width: '70%',
          height: '70%',
          data: {expenseId: expenseId, goalType: goalType},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved){
              //this.refreshExpense(result.expense);
              this.dataService.getGoalSummary();
            }
          });        
        break;
      }       
    }
  }

  showGoalExpense(goal){
    if(goal.goalId){
      this.showDetails = true;
      this.selectedGoalSummary = goal;
      this.selectedGoalId = goal.goalId;    
    } else {
      //this.showCreateGoalExpense(goal);
      this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITEXPENSE, '', goal.goalType);      
      // if(goal.goalType===fromModel.GOALTYPE.LGY){        
      //   //this.menuTrigger.openMenu();
      // } else {
      //   //this.menuTrigger.closeMenu();
      //   this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITEXPENSE, '', goal.goalType);
      // }
    }
  }

  // createGoal(){
  // }

  showHideEdit(){
    this.showEdit = !this.showEdit;
  }

  closeDetailsOverlay(){
    this.showDetails = false;
    this.selectedGoalSummary = null;
    this.selectedGoalId = '';
    this.showEdit = false;
  }

  refreshMe(){    
    this.refreshGoalExpense = true; 
    //this.dataService.getGoalSummary();
    this.selectedGoalSummary = null;
    // this.selectedGoalId = '';

    let _goal = this.dataService.getGoalByGoalId(this.selectedGoalId);
    if(!_goal){ //goal is deleted
      this.closeDetailsOverlay();
      this.dataService.getGoalSummary();
    } else {
      let _goalSummary = this.dataService.getGoalSummaryByGoalId(this.selectedGoalId);
    }
    // this.selectedGoalId = '';
    // this.showGoalExpense(_goalSummary);    
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }
}
